import { render, staticRenderFns } from "./TabListSPK.vue?vue&type=template&id=458b5464&scoped=true"
import script from "./TabListSPK.vue?vue&type=script&lang=js"
export * from "./TabListSPK.vue?vue&type=script&lang=js"
import style0 from "./TabListSPK.vue?vue&type=style&index=0&id=458b5464&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458b5464",
  null
  
)

export default component.exports